import styled from '@emotion/styled';
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { markAllAsRead } from 'modules/notifications/actions';
import { isFetching } from 'modules/notifications/selectors/ui';
import { getCurrentUserId, getCurrentUserIsReadOnly, isImpersonatingUser } from 'modules/users/selectors/currentUser';

import { Row, Col, Button } from 'ui/base';

const Wrapper = styled(Row)`
  margin-bottom: 24px;
`;

const UnderlinedButton = styled(Button)`
  text-decoration: ${({ disabled }) => (disabled ? 'none' : 'underline')};
`;

/** @returns {React.FC<HTMLHyperlinkElementUtils>} */
const MarkAllAsRead = ({ disabled, className, ...rest }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isFetching);
  const isReadOnly = useSelector(getCurrentUserIsReadOnly);
  const isImpersonating = useSelector(isImpersonatingUser);
  const userId = useSelector(getCurrentUserId);
  const isDisabled = disabled || isLoading || isReadOnly || isImpersonating;

  const handleClick = () => {
    dispatch(markAllAsRead(userId));
  };

  return (
    <Wrapper type="flex" justify="end" gutter={8} className={classnames(className)}>
      <Col>{isLoading && <span className="fb-icon-spin fb-icon--spin" />}</Col>
      <Col>
        <UnderlinedButton
          type="link"
          onClick={handleClick}
          disabled={isDisabled}
          data-cy="mark-all-read"
          className="border-0"
          {...rest}
        >
          <FormattedMessage id="notifications.dashboard.markAllAsRead" defaultMessage="Mark everything as read" />
        </UnderlinedButton>
      </Col>
    </Wrapper>
  );
};

export default MarkAllAsRead;
